import { connect, mapProps } from '@formily/react';
import { CnReadonly as UiReadOnly } from '@/components/cn-readonly';
import { mapSize, mapStatus } from '@/form/__builtins__';
export const CnReadOnly = connect(UiReadOnly, mapProps(mapSize, mapStatus));
CnReadOnly.displayName = 'CnReadOnly';
